import { CollapseWrapper } from '@components/Collapse';
import { $sceneMapApi } from '@stores/dataStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedScene } from '@stores/loadedStore';
import { useStore } from 'effector-react';
import { useEffect, useState } from 'react';
import PanelHotspot from '../../panel/PanelHotspot/PanelHotspot';
import { krpAddHotspot } from '../index';
import { HotspotBatchModeList } from './HotspotBatchModeList';
import { HotspotGroupModeList } from './HotspotGroupModeList';
import { HotspotLayerModeList } from './HotspotLayerModeList';
import { HotspotList } from './HotspotList';

type Mode = 'list' | 'batch' | 'group' | 'layer';

function SidebarHotspot() {
  const scene = useStore($loadedScene)!;
  const hotspotList = scene.hotspot ?? [];
  const [mode, setMode] = useState<Mode>('list');

  useEffect(() => {
    hotspotList.forEach((x) => {
      krpAddHotspot(x);
    });
    return () => {
      MainPlayer.get()?.removeAllHotspots();
    };
  }, []);

  useEffect(() => {
    // fix: 有用户数据里出现groups.list下存在空字符串项的问题
    const { groups } = scene;
    const hasEmpty = !!groups?.list?.some((x) => !x);
    if (hasEmpty) {
      $sceneMapApi.updateScene({
        id: scene.id,
        updater: (draft) => {
          const list = draft.groups?.list;
          if (list) {
            draft.groups!.list = list.filter((x) => x);
          }
        },
      });
    }
  }, []);

  return (
    <CollapseWrapper>
      <div className="absolute inset-0 flex flex-col">
        {mode === 'list' && (
          <HotspotList
            scene={scene}
            onLayerClick={() => {
              MainPlayer.get()?.removeAllHotspots();
              setMode('layer');
            }}
            onBatchClick={() => setMode('batch')}
            onGroupClick={() => setMode('group')}
          />
        )}
        {mode === 'batch' && (
          <HotspotBatchModeList
            scene={scene}
            onQuitClick={() => setMode('list')}
          />
        )}
        {mode === 'group' && (
          <HotspotGroupModeList
            scene={scene}
            onQuitClick={() => setMode('list')}
          />
        )}
        {mode === 'layer' && (
          <HotspotLayerModeList
            scene={scene}
            onQuitClick={() => {
              setMode('list');
              MainPlayer.get()?.removeAllHotspots();
              hotspotList.forEach((x) => {
                krpAddHotspot(x);
              });
            }}
          />
        )}
      </div>
      <PanelHotspot />
    </CollapseWrapper>
  );
}

export default SidebarHotspot;
